import { ProductId } from "@settings/products";

export interface ProductDTO {
  id: ProductId;
  name: string;
  price: number;
  selected: boolean;
}

export class Product implements ProductDTO {
  readonly id: ProductId;
  readonly name: string;
  readonly price: number;
  readonly selected: boolean;

  constructor(attrs: ProductDTO) {
    Object.assign(this, attrs);
  }

  get taxKey(): string {
    if (this.id === ProductId.prevention) {
      return "details.summary.taxes.vat";
    }

    return "details.summary.taxes.ipt";
  }
}
